// consts
const PING_INTERVAL = 10000
const PING_TIMEOUT = 9000
const PING_PREFIX = 'PING'.padEnd(64, '_')

const ping = {
  pingStart() {
    this.pingId = 0
    this.pingInterval = setInterval(() => {
      if (!this.isOpen()) return

      this.pingId += 1
      this.send(`${PING_PREFIX}${this.pingId}`)
      this.pingTimeout = setTimeout(this.myClose, PING_TIMEOUT, 'Ping Timeout')
    }, PING_INTERVAL)
  },

  /**
   * Checks the message and handles pingPong if it's a PONG message
   * @param data the received message
   * @returns {boolean} true if it was a PONG message
   */
  pingHandle(data) {
    if (typeof data === 'string' && data.startsWith(PING_PREFIX)) {
      const id = Number(data.slice(PING_PREFIX.length))
      if (id === this.pingId) clearTimeout(this.pingTimeout)
      return true
    }
    return false
  },

  pingStop() {
    if (this.pingInterval) clearInterval(this.pingInterval)
    if (this.pingTimeout) clearTimeout(this.pingTimeout)
  },
}

Object.keys(ping).forEach(key => {
  window.WebSocket.prototype[key] = ping[key]
})
